import { fmtNumber } from "@/lib/i18n";

const ITALY_KM2 = 302073;
const pick = (o, lang) => (o && (o[lang] || o.en)) || "";
const join = (parts) => parts.filter(Boolean).join(" ");
const list = (items, lang) => new Intl.ListFormat ? new Intl.ListFormat(lang === "ar" ? "ar" : lang, { type: "conjunction" }).format(items) : items.join(", ");

/** One short spoken sentence per slide — the only "text" the viewer has to follow (karaoke line). */
export function narrationFor(key, country, facts, lang, t) {
  const c = country;
  switch (key) {
    case "flag": return join([`${c.names[lang] || c.names.en}.`, `${t("capital")}: ${pick(c.capital, lang)}.`]);
    case "population": return join([`${fmtNumber(c.population, lang)} ${t("story_people")}.`, c.largest_city ? `${t("largest_city")}: ${pick(c.largest_city.name, lang)}.` : ""]);
    case "area": {
      const r = c.area_km2 / ITALY_KM2;
      const cmp = r >= 1 ? t("story_times_italy").replace("{x}", fmtNumber(Math.round(r * 10) / 10, lang)) : t("story_pct_italy").replace("{x}", fmtNumber(Math.round(r * 100), lang));
      return `${fmtNumber(c.area_km2, lang)} ${t("km2")}: ${cmp}.`;
    }
    case "cities": {
      const places = (c.travel_guide?.places || []).slice(0, 3).map((p) => pick(p.name, lang));
      return join([`${t("capital")}: ${pick(c.capital, lang)}.`, places.length ? `${t("story_cities")}: ${list(places, lang)}.` : ""]);
    }
    case "food": {
      const cu = c.travel_guide?.cuisine || {};
      const names = ["dish", "dessert", "street"].filter((k) => cu[k]).map((k) => pick(cu[k].name, lang));
      return `${t("story_food")}: ${list(names, lang)}.`;
    }
    case "history": return pick(c.historical_note, lang);
    case "nature": return pick(facts?.curiosity, lang) || pick(c.nature?.fauna, lang);
    case "currency": return join([`${t("currency")}: ${pick(c.currency, lang)}.`, pick(c.economy_base, lang)]);
    case "languages": return pick(facts?.languages, lang);
    case "climate": return join([pick(c.travel_guide?.best_time, lang) ? `${pick(c.travel_guide.best_time, lang)}.` : "", pick(facts?.climate, lang)]);
    default: return t("story_end_title");
  }
}
